<div *ngIf="flowTypes.length > 1 || localities.length > 1" class="filter-pane">
  <h1>{{'Filter' | translate}}</h1>
  <div class="column">
    <app-object-dropdown *ngIf="localities.length > 1" class="width-80" [label]="'Locality'" [objects]="localities"
      (objectChange)="onLocality($event)"></app-object-dropdown>
    <app-object-dropdown *ngIf="flowTypes.length > 1" class="width-80" [label]="'Flow Type'" [objects]="flowTypes"
      (objectChange)="onFlowType($event)"></app-object-dropdown>
  </div>
</div>
